module.exports = function() {
	const $btn_more = $('.js-list_more');
	const $list = $('.js-post_list');
	const $post = $('.js-post_list-post');
	const $tag = $('.js-tag_list .post_tag');
	const active_flg = 'active';
	const fade_speed = 200;
	let category,$target,$target_all;
	let shownum = 10;

	if($list.data('shownum') > 0){
		shownum = $list.data('shownum');
	}

	if($post.length > shownum){
		$btn_more.show();
	}
	$btn_more.on('click',function(){
		$(this).fadeOut(fade_speed);
		$list.find('.js-post_list-post').addClass(active_flg);
		return false;
	});

	$tag.on('click',function(){
		$btn_more.hide();
		$post.hide();
		$tag.removeClass(active_flg);
		$(this).addClass(active_flg);

		category = '.' + $(this).data('category');

		if(category == '.post_all'){
			$target = $('.js-post_list-post:lt('+shownum+')');
			$target_all = $('.js-post_list-post');
		}else{
			$target = $('.js-post_list-post'+category+':lt('+shownum+')');
			$target_all = $('.js-post_list-post'+category);
		}

		$target.show();

		if($target_all.length > shownum){
			$btn_more.show();
			$btn_more
			.off('click')
			.on('click',function(){
				$(this).fadeOut(fade_speed);
				$target_all.show();
				return false;
			});
		}

	});
}



// WEBPACK FOOTER //
// ./dev/js/scripts/category_sort_pagenation.js